import {UntypedFormGroup} from '@angular/forms';
import {FormValueModel} from '../../../../../../form/form/value/api/entity/formValue.model';
import {Injectable, Injector, Type} from '@angular/core';
import {AgendaContext} from '../../../../event/api/entity/agendaEvent.model';
import {AgendaCategoryHolderFindAllService} from '../agendaCategoryHolderFindAll.service';

export enum AgendaCategoryHolderServiceType {
    FIND_ALL = 'FIND_ALL'
}


@Injectable({
    providedIn: 'root'
})
export class  AgendaCategoryHolderServiceRegister{
    constructor(private injector: Injector) {
    }
    private classes: Map<string, Type<any>> = new Map();
    register(clazz: Type<any>, context: AgendaContext, type: AgendaCategoryHolderServiceType) {
        // console.log(['FieldInputJsonHandlerRegister: register ', clazz, fieldNames, FieldInputJsonHandlerRegister.classes]);
        const key = this.buildKey(context, type);
        if (!this.getImplementationClazz(context, type)) {
            this.classes.set(key, clazz);
        }
    }

    getImplementationClazz(context: AgendaContext, type: AgendaCategoryHolderServiceType): any {
        return this.classes.get(this.buildKey(context, type));
    }

    getImplementation(context: AgendaContext, type: AgendaCategoryHolderServiceType): any {
        const clazz = this.getImplementationClazz(context, type);
        return this.injector.get(clazz);
    }

    getFindAllImplementation(context: AgendaContext) {
        return this.getImplementation(context, AgendaCategoryHolderServiceType.FIND_ALL) as AgendaCategoryHolderFindAllService<any, any>;
    }

    private buildKey(context: AgendaContext, type: AgendaCategoryHolderServiceType) {
        return context + '____' + type;
    }
}
